import { CONTENT_ANCHORING, PositionedUI } from './PositionedUI';

export class PinUI extends PositionedUI {
  constructor(hud, layer, position, icon) {
    super(hud, layer, position, createIconHost(icon), CONTENT_ANCHORING.BOTTOM_CENTER);

    this.iconHost = this.innerDom.firstChild;
    const pinGroup = this.iconHost.firstChild;
    this.pin = pinGroup.firstChild;
    this.status = pinGroup.childNodes[1];
    this.icon = pinGroup.childNodes[2];

    this.backgroundColor = '';
    this.isSelected = false;
  }

  hideIcon() {
    this.icon.style.display = 'none';
  }

  setBGColor(bgColor) {
    if (this.backgroundColor === bgColor) return;

    this.backgroundColor = bgColor;
    this.status.setAttribute('fill', this.backgroundColor);
  }

  setSelected(value) {
    value = Boolean(value);
    if (value === this.isSelected) return;

    this.pin.setAttribute('stroke-width', value ? '1' : '0');
    this.isSelected = value;
  }
}

const createIconHost = (icon) => {
  return [
  '<svg class="pin-ui" style="display: block" fill="white" width="26" height="33" viewbox="0 0 26 33" xmlns="http://www.w3.org/2000/svg">',
  '<g transform="translate(1 1)">',
  '<path d="M0 12C0 5.4 5.4 -0 12 -0C18.6 -0 24 5.4 24 12C24 15 22.9 17.7 21.1 19.8L12 30.5L2.9 19.8C1 17.7 0 15 0 12Z" stroke="#0696D7" stroke-width="0" />',
  '<circle cx="12" cy="12" r="10" stroke-width="0" />',
  '<g transform="translate(12 12)">',
  icon,
  '</g>',
  '</g>',
  '</svg>'].
  join('');
};